<script>
import GenericCrud from "@forms/GenericCrud.vue";
import ClienteContato from "@forms/ClienteContato.vue";
import api from "@services/api";
import _ from "lodash";

export default {
  extends: GenericCrud,
  components: { ClienteContato },
  props: {
    table: {
      type: String,
      default: "Cliente"
    }
  },
  data: () => ({
    contato: {},
    indexContato: null,
    showModalContato: false
  }),
  methods: {
    get(id) {
      api
        .get(`crud/${this.table}/${id}`, {
          params: {
            include: "ClienteContatos"
          }
        })
        .then(response => (this.item = response.data["data"]));
    },
    openModalContato(index) {
      this.indexContato = index;
      this.contato = _.clone(this.item.clienteContatos[index]);
      this.showModalContato = true;
    },
    openModalContatoNovo() {
      this.indexContato = null;
      this.contato = { clienteId: this.item.id };
      this.showModalContato = true;
    },
    saveModalContato() {
      if (!this.item.clienteContatos) {
        this.item.clienteContatos = [];
      }
      var index =
        this.indexContato != null
          ? this.indexContato
          : this.item.clienteContatos.length;
      this.item.clienteContatos[index] = _.clone(this.contato);
      this.contato = {};
      this.showModalContato = false;
      this.indexContato = null;
    },
    closeModalContato() {
      this.showModalContato = false;
      this.contato = {};
      this.indexContato = null;
    },
    removeContato(index) {
      this.item.clienteContatos.splice(index, 1);
    }
  }
};
</script>

<template>
  <div>
    <b-form @submit.prevent="save">
      <div class="row">
        <b-form-group
          id="input-group-1"
          label="Nome"
          label-for="nome"
          class="col-md-4"
        >
          <b-form-input
            id="nome"
            v-model="item.nome"
            type="text"
            :disabled="!this.editForm"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-1"
          label="Nome Completo"
          label-for="nomeCompleto"
          class="col-md-8"
        >
          <b-form-input
            id="nomeCompleto"
            v-model="item.nomeCompleto"
            type="text"
            :disabled="!this.editForm"
            required
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="row">
        <b-form-group
          class="col-md-4"
          id="input-group-1"
          label="Tipo"
          label-for="tipo"
        >
          <b-form-select
            v-model="item.tipo"
            class="mb-3"
            required
            :disabled="!this.editForm"
          >
            <b-form-select-option disabled :value="undefined"
              >Selecione um item da lista</b-form-select-option
            >
            <b-form-select-option value="PJ"
              >Pessoa Jurídica</b-form-select-option
            >
            <b-form-select-option value="PF"
              >Pessoa Física</b-form-select-option
            >
          </b-form-select>
        </b-form-group>

        <b-form-group id="input-group-1" class="float-right mt-4 col-md-2">
          <b-form-checkbox
            v-model="item.acessoChamado"
            :disabled="!this.editForm"
            name="check-button2"
            switch
          >
            Realiza Chamado
          </b-form-checkbox>
        </b-form-group>

        <b-form-group id="input-group-1" class="float-right mt-4 col-md-2">
          <b-form-checkbox
            v-model="item.visualizaTarefa"
            :disabled="!this.editForm"
            name="check-button2"
            switch
          >
            Visualiza Tarefas
          </b-form-checkbox>
        </b-form-group>

        <b-form-group
          class="col-md-8"
          id="input-group-1"
          label="CNPJ"
          label-for="cnpj"
          v-if="item.tipo == 'PJ'"
        >
          <b-form-input
            id="cnpj"
            v-model="item.cpfcnpj"
            :disabled="!this.editForm"
            v-mask="'##.###.###/####-##'"
            placeholder="00.000.000/0000-00"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          class="col-md-8"
          id="input-group-1"
          label="CPF"
          label-for="cpf"
          v-if="item.tipo == 'PF'"
        >
          <b-form-input
            id="cpf"
            v-model="item.cpfcnpj"
            :disabled="!this.editForm"
            v-mask="'###.###.###-##'"
            placeholder="000.000.000-00"
            required
          ></b-form-input>
        </b-form-group>
      </div>

      <b-form-group id="input-group-1" label="Endereço" label-for="endereco">
        <b-form-input
          id="endereco"
          v-model="item.endereco"
          type="text"
          :disabled="!this.editForm"
          required
        ></b-form-input>
      </b-form-group>

      <div class="row">
        <b-form-group
          id="input-group-1"
          class="col-md-3"
          label="UF"
          label-for="uf"
        >
          <b-form-select
            required
            v-model="item.uf"
            class="mb-3"
            :disabled="!this.editForm"
          >
            <b-form-select-option disabled :value="undefined"
              >Selecione um item da lista</b-form-select-option
            >
            <b-form-select-option value="AC">Acre</b-form-select-option>
            <b-form-select-option value="AL">Alagoas</b-form-select-option>
            <b-form-select-option value="AP">Amapá</b-form-select-option>
            <b-form-select-option value="AM">Amazonas</b-form-select-option>
            <b-form-select-option value="BA">Bahia</b-form-select-option>
            <b-form-select-option value="CE">Ceará</b-form-select-option>
            <b-form-select-option value="DF"
              >Distrito Federal</b-form-select-option
            >
            <b-form-select-option value="ES"
              >Espírito Santo</b-form-select-option
            >
            <b-form-select-option value="GO">Goiás</b-form-select-option>
            <b-form-select-option value="MA">Maranhão</b-form-select-option>
            <b-form-select-option value="MT">Mato Grosso</b-form-select-option>
            <b-form-select-option value="MS"
              >Mato Grosso do Sul</b-form-select-option
            >
            <b-form-select-option value="MG"
              >Minas Gerais</b-form-select-option
            >
            <b-form-select-option value="PA">Pará</b-form-select-option>
            <b-form-select-option value="PB">Paraíba</b-form-select-option>
            <b-form-select-option value="PR">Paraná</b-form-select-option>
            <b-form-select-option value="PE">Pernambuco</b-form-select-option>
            <b-form-select-option value="PI">Piauí</b-form-select-option>
            <b-form-select-option value="RJ"
              >Rio de Janeiro</b-form-select-option
            >
            <b-form-select-option value="RN"
              >Rio Grande do Norte</b-form-select-option
            >
            <b-form-select-option value="RS"
              >Rio Grande do Sul</b-form-select-option
            >
            <b-form-select-option value="RO">Rondônia</b-form-select-option>
            <b-form-select-option value="RR">Roraima</b-form-select-option>
            <b-form-select-option value="SC"
              >Santa Catarina</b-form-select-option
            >
            <b-form-select-option value="SP">São Paulo</b-form-select-option>
            <b-form-select-option value="SE">Sergipe</b-form-select-option>
            <b-form-select-option value="TO">Tocantins</b-form-select-option>
          </b-form-select>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          class="col-md-3"
          label="Município"
          label-for="municipio"
        >
          <b-form-input
            id="municipio"
            v-model="item.municipio"
            type="text"
            :disabled="!this.editForm"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          class="mb-4 col-md-6"
          label="Bairro"
          label-for="bairro"
        >
          <b-form-input
            id="bairro"
            v-model="item.bairro"
            type="text"
            :disabled="!this.editForm"
            required
          ></b-form-input>
        </b-form-group>
      </div>

      <b-button
        class="btn btn-icon mb-2 float-right"
        v-on:click="openModalContatoNovo()"
        :disabled="!editForm"
        variant="primary"
        >Adicionar novo contato</b-button
      >
      <b-form-group id="input-group-1" label="Contatos" label-for="contatos">
        <table class="table b-table table table-hover">
          <thead class="thead-primary">
            <tr>
              <th class="columnheader" scope="col">
                Nome
              </th>
              <th scope="col">
                E-mail
              </th>
              <th scope="col">
                Telefone
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in item.clienteContatos" :key="item.id">
              <th scope="row">
                {{ item.nome }}
              </th>
              <td>
                {{ item.email }}
              </td>
              <td>
                {{ item.telefone }}
              </td>
              <td>
                <div class="float-right">
                  <b-button
                    class="btn btn-icon"
                    v-on:click="openModalContato(index)"
                    :disabled="!editForm"
                    variant="primary"
                  >
                    <i class="fe-edit" />
                  </b-button>
                  <b-button
                    variant="danger"
                    class="btn btn-icon ml-2"
                    v-on:click="removeContato(index)"
                    :disabled="!editForm"
                  >
                    <i class="fe-delete" />
                  </b-button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Cancelar</b-button
        >
        <b-button type="submit" variant="primary" class="btn ml-2"
          >Salvar</b-button
        >
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="!this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Voltar</b-button
        >
        <b-button variant="primary" class="btn ml-2" v-on:click="edit()"
          >Editar</b-button
        >
        <b-button variant="danger" class="btn ml-2" v-on:click="remove()"
          >Remover</b-button
        >
      </b-form-group>
    </b-form>

    <b-modal
      v-model="showModalDelete"
      title="Deseja realmente excluir?"
      centered
      hide-footer
      @hidden="cancelRemove()"
    >
      <div class="button-list float-right">
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="confirmRemove()"
          >Sim</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="showModalDelete = false"
          >Não</b-button
        >
      </div>
    </b-modal>

    <b-modal v-model="showModalContato" title="Contato" centered hide-footer>
      <ClienteContato :editable="true" :item="contato" />
      <div class="button-list float-right">
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="saveModalContato()"
          >Salvar</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="closeModalContato()"
          >Cancelar</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
